import { render, staticRenderFns } from "./transprotPostManage.vue?vue&type=template&id=6b2207e3&scoped=true"
import script from "./transprotPostManage.vue?vue&type=script&lang=js"
export * from "./transprotPostManage.vue?vue&type=script&lang=js"
import style0 from "./transprotPostManage.vue?vue&type=style&index=0&id=6b2207e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2207e3",
  null
  
)

export default component.exports